<template>
  <div class="selection" v-if="RMTPermission && getResources.length > 0">
    <div class="search-menu-label">
      REMOVE
    </div>
    <div class="delete-circle">
      <div class="icon-size-del">
        <img
            :src="require('@/assets/svg/SVG/del.svg')"
            class="del-icon"
            title="Delete Selected Collection"
            @mouseup="confirmDeleteAll"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {useRMTStore} from '@/store/RMTStore';
import {storeToRefs} from 'pinia/dist/pinia';
import {useModalStore} from '@/store/ModalStore';

export default {
  name: 'RemoveButton',
  data () {
    return {
      deleteCnt : 0
    };
  },
  setup () {
    const RMTStore = useRMTStore();
    const modalStore = useModalStore();
    const { RMTPermission } = storeToRefs(RMTStore);
    return {
      RMTStore,  RMTPermission, modalStore
    };
  },
  computed: {
    getResources () {
      let resources = (!this.RMTStore.inUploadMode) ? this.RMTStore.selectedResources : this.RMTStore.uploads;
      return resources;
    }
  },
  methods: {
    confirmDeleteAll () {
      // TODO: fix RMTSearchType....
      const description = (this.RMTSearchType === 1 && this.$props.display === 'collection') ? 'Are you sure you want to delete the selected collection' : 'Are you sure you want to delete all selected items?';
      this.modalStore.setModalObj({
        promptLabel: 'Delete Selected Resource',
        promptDescription: description,
        buttonBLabel: 'CONFIRM',
        buttonBFunc: this.deleteAll,
        buttonALabel: 'Cancel',
        buttonAFunc: this.cancelPrompt
      });
      this.modalStore.showModal('prompt');
    },
    deleteAll () {

      if (this.RMTStore.searchType === 0) {
        let resources = (!this.RMTStore.inUploadMode) ? this.RMTStore.selectedResources : this.RMTStore.uploads;
        this.$data.deleteCnt = resources.length - 1;
        this.deleteResource(resources[this.$data.deleteCnt]);
      } else {
        let collection = this.RMTStore.selectedCollections[0];
        this.RMTStore.removeCollection(collection.cID).then(() => {
          const modalStore = useModalStore();
          modalStore.showSnack('Collection Removed.');
          this.RMTStore.resetCollectionView();
          this.RMTStore.filterCollections('reset page');
        });
      }
      // });

/*      if (this.$props.display === 'collection') {
        this.RMTStore.removeCollection(this.RMTStore.uploadedFileData[0].cID);
      } else if (this.$props.display === 'edit') {
        const collectionId = this.RMTStore.uploadedFiles[0].cID;
        const pk = this.RMTStore.editCollectionItems.map((item) => {
          return item.key;
        });
        this.RMTStore.collectionUnlinkResources(collectionId, pk);
      } else if (this.RMTSearchType === 0 && this.RMTStore.inUploadMode === false) {
        this.selections.forEach((item) => {
          this.RMTStore.removeResources(item.key);
        });
        // This is the code for remove images out of upload. Still trying to get that to work
      } else if (this.RMTStore.inUploadMode === true) {
        this.RMTStore.selectedUploads.forEach((element) => {
          URL.revokeObjectURL(element.imageUri);
          this.RMTStore.filterUploadResources = this.RMTStore.filterUploadResources.filter((id) => id != element);
        });
        this.RMTStore.uploads[0].isSelected = true;*/

      // this.modalStore.hideModal();
    },

    deleteResource (resource) {

      this.RMTStore.deleteResource(resource.key).then(() => {
        this.$data.deleteCnt--;
        if (this.$data.deleteCnt > -1) {
          let resources = (!this.RMTStore.inUploadMode) ? this.RMTStore.selectedResources : this.RMTStore.uploads;
          let r = resources[this.$data.deleteCnt];
          this.deleteResource(r);
        } else {
          this.RMTStore.clearSelectedResources();
          this.RMTStore.filterResources();
          this.modalStore.hideModal();
          this.RMTStore.setPanelIsHidden(true);
        }
      });

    },

    cancelPrompt () {
      this.modalStore.hideModal();
    },

  }
};
</script>

<style scoped>

.selection {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: center;
  flex-wrap: wrap;
}


.delete-circle {
  width: 30px;
  height: 30px;
  border-radius: 15px;
  background-color: lightgrey;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
}

.icon-size-del {
  padding-top: 4px;
}

.del-icon {
  width: 15px;
  height: 15px;
}

</style>